module.exports = __webpack_public_path__ + "img/b6835cbb86c59e5cda98cd6d97141122.png";